import React, { Component } from "react";
import TemplatePage from "./TemplatePage";
import "./PrintTemplates.css";

// Loads the print configs of the store in the URL (default: the store signed
// into). getPrintConfigsList leaves redux alone: config.PrintConfigs is what the
// billing screens print from, so it must keep holding the signed-in store.
const withStoreTemplates = (Screen) =>
  class extends Component {
    constructor(props) {
      super(props);
      this.state = { stores: [], printConfigs: null };
    }

    get storeKey() {
      const store = new URLSearchParams(this.props.location.search).get("store");
      return store || this.props.user.store.key;
    }

    async componentDidMount() {
      this.loadTemplates();
      const { user } = this.props;
      try {
        const stores = await this.props.getUserStores(
          user.user.RegistrationID,
          user.auth && user.auth.uid
        );
        this.setState({ stores: stores || [] });
      } catch (error) {
        this.setState({ stores: [] });
      }
    }

    componentDidUpdate(prevProps) {
      if (prevProps.location.search !== this.props.location.search) {
        this.setState({ printConfigs: null });
        this.loadTemplates();
      }
    }

    loadTemplates = async () => {
      const storeKey = this.storeKey;
      try {
        const printConfigs = await this.props.getPrintConfigsList(
          this.props.user.user.RegistrationID,
          storeKey
        );
        if (storeKey === this.storeKey) {
          this.setState({ printConfigs: printConfigs || [] });
        }
      } catch (error) {
        this.props.getToastr("Could not load the print templates");
        this.setState({ printConfigs: [] });
      }
    };

    // After a save. Billing must also see the change if it is the signed-in store.
    reloadTemplates = async () => {
      const { user } = this.props;
      await this.loadTemplates();
      if (this.storeKey === user.store.key) {
        await this.props.getPrintConfigs(user.user.RegistrationID, user.store.key);
      }
    };

    render() {
      const { user } = this.props;
      const { stores, printConfigs } = this.state;

      if (printConfigs === null) {
        return (
          <TemplatePage {...this.props} title="Print Templates">
            <div className="pt-empty pt-empty--loading">Loading templates...</div>
          </TemplatePage>
        );
      }

      const listed = stores.some((s) => s.key === user.store.key)
        ? stores
        : [user.store, ...stores];

      return (
        <Screen
          {...this.props}
          stores={listed}
          storeKey={this.storeKey}
          store={listed.find((s) => s.key === this.storeKey) || user.store}
          printConfigs={printConfigs}
          reloadTemplates={this.reloadTemplates}
        />
      );
    }
  };

export default withStoreTemplates;
